import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useForm, Controller } from 'react-hook-form';
import DefaultModal from '../../../../../components/Modal/DefaultModal';
import Service from '../../../service';
import { ErrorMessage } from '@hookform/error-message';

import { Row, Form, Col, Input, Button } from 'reactstrap';

const ConfirmModal = ({
  isModalOpen,
  onModalToggle,
  flexIACopy,
  handleGetFlexIA,
  activePage,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  const onSubmit = async (data) => {
    try {
      const dataToSubmit = {
        ...flexIACopy,
        name: data.name
      };

      await Service.createFlexia(dataToSubmit);
      handleGetFlexIA(activePage);
    } catch (err) {
      toast.error(
        err.response.data.message ||
          'Ops, algo errado aconteceu ao clonar FlexIA!',
        {
          autoClose: 3000,
          closeOnClick: true
        }
      );
    } finally {
      closeModal();
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );
  const { control, handleSubmit, errors } = useForm();
  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Confirmação de cópia da FlexIA"
      showCloseButton={false}
      modalContainerClasses="modal-sm"
      {...props}
    >
      <>
        <Form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md="12">
              <label className="form-control-label">Novo nome da FlexIA*</label>
              <Controller
                as={Input}
                control={control}
                name="name"
                rules={{ required: 'Nome é obrigatório!' }}
                defaultValue=""
              />
              <ErrorMessage
                errors={errors}
                name="name"
                render={({ message }) => errorFormMessage(message)}
              />
            </Col>
          </Row>

          <hr />
          <Button color="primary" type="submit">
            Confirmar cópia
          </Button>
          <Button color="danger" onClick={() => closeModal()}>
            Cancelar
          </Button>
        </Form>
      </>
    </DefaultModal>
  );
};

export default ConfirmModal;
